import React from 'react'
import { Box, Container, Fab, Grid, Toolbar, Typography } from "@material-ui/core";
import MemberCard from "./MemberCard";
import { members } from '../../data/members';
import SectionContainer from '../../components/SectionContainer';
import TypoTitle from '../../components/Typography/TypoTitle';
import TypoOutlined from '../../components/Typography/TypoOutlined';
import { makeStyles } from '@material-ui/core/styles'
import '../../scss/styles.scss'
import Footer from '../../components/Footer/Footer';
import { ScrollTop } from '../../components/BackToTop';
import { KeyboardArrowUp } from '@material-ui/icons';


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'white'
  },
  heroTitle: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(8)
    },
    [theme.breakpoints.between('xs', 'md')]: {
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1)
    }
  }
}))

const MembersList = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Toolbar id="back-to-top-anchor" style={{ backgroundColor: 'black' }} />
      <SectionContainer backgroundColor="black">
        <Box className={classes.heroTitle}>
          <Box marginTop={4}>
            <TypoTitle text={'Our Team'} color={'white'} fontSize={'4vw'} />
          </Box>
          <Box>
            <TypoOutlined text={'EXPERTISE.'} color={'black'} />
          </Box>
          <Typography variant="h6" style={{ color: 'white', marginTop: 20, marginBottom: 40 }}>
            Meet our skilled developers delivering innovative mobile, web, and full-stack solutions.
          </Typography>
        </Box>
      </SectionContainer>
      <SectionContainer sx={{ backgroundColor: '#ffffff'}}>
        <Grid container spacing={4} style={{marginTop: '20px', backgroundColor: '#ffffff' }}>
          {members.map((member, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <MemberCard member={member} />
            </Grid>
          ))}
        </Grid>
      </SectionContainer>
      <Box marginTop={8}>
        <Footer />
      </Box>

      <ScrollTop {...props}>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUp />
        </Fab>
      </ScrollTop>
    </div>
  );
};

export default MembersList;
